// https://vuex.vuejs.org/en/state.html
/* eslint no-param-reassign:0 */
export default {
  name: state => state.name,
  files: state => state.files,
  relations: state => state.relations,
};
